<template>
  <section v-if="isChatBotVisible">
    <div  
      class="fitclass-subscribers-wrap mb-6"
      v-bind:class="{ openWidth: !isActiveAIChat }">
      <div
        class="fitclass-subscribers popup-ani"
        v-bind:class="{ open: isActiveAIChat }"
      >
        <iframe
          src="https://www.chatbase.co/chatbot-iframe/gqbqBy1Uex3jethoOVU77"
          width="100%"
          height="470"
          frameborder="0"
        ></iframe>
      </div>
      <div class="fitclass-subscribers-fab bg-green-light cursor-pointer">
          <div
            @click="toggleAIChatHanlder"
            class="h-full flex items-center justify-center text-white"
            v-bind:class="{ close: isActiveAIChat }"
          >
            <svg
              v-if="!isActiveAIChat"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-message-square"
            >
              <path
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
              ></path>
            </svg>
            <svg
              v-else
              fill="none"
              stroke="#FFF"
              stroke-width="2"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              class="feather feather-message-square"
            >
              <path d="M12 4.5v15m7.5-7.5h-15"></path>
            </svg>
          </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.fitclass-subscribers {
  width: 290px;
  height: 50px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0px 12px 45px rgba(0, 0, 0, 0.15);
  font-family: "Roboto", sans-serif;
  text-align: center;
  margin: 0 0 10px 0;
  overflow: hidden;
  opacity: 0;
}
.fitclass-subscribers.open {
  height: 470px;
  opacity: 1;
}
.fitclass-subscribers.popup-ani {
  -webkit-transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition: all 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.fitclass-subscribers-fab {
  width: 50px;
  height: 50px;
  border-radius: 30px;
  float: right;
  box-shadow: 0px 12px 45px rgba(0, 0, 0, 0.3);
  z-index: 5;
  position: relative;
}
.fitclass-subscribers-fab .icon-fab {
  height: 30px;
  width: 30px;
  color: #fff;
}
.fitclass-subscribers-fab .wrap {
  transform: rotate(0deg);
  -webkit-transition: all 0.15s cubic-bezier(0.15, 0.87, 0.45, 1.23);
  transition: all 0.15s cubic-bezier(0.15, 0.87, 0.45, 1.23);
}
.fitclass-subscribers-fab .close {
  transform: rotate(-45deg);
  -webkit-transition: all 0.15s cubic-bezier(0.15, 0.87, 0.45, 1.23);
  transition: all 0.15s cubic-bezier(0.15, 0.87, 0.45, 1.23);
  float: none;
  opacity: 1;
}
.fitclass-subscribers-wrap.openWidth{
  width: 0px;
}
.fitclass-subscribers-wrap {
  position: fixed;
  right: 25px;
  bottom: 25px;
  z-index: 1000;
}
</style>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ChatBot",
  data() {
    return {
      isActiveAIChat: false,
    };
  },
  methods: {
    toggleAIChatHanlder() {
      this.isActiveAIChat = !this.isActiveAIChat;
    },
  },
  computed: {
    ...mapGetters([
      'isChatBotVisible'
    ])
  }
};
</script>